'use strict';

angular.module('user')
    .component('logoutButton', {
        templateUrl: 'js/modules/user/components/logout-button/template.html',
        controller: 'LogoutButtonController',
    });
